
import { defineComponent, onMounted, ref, Ref } from "vue";
import { api } from "@/services/reports/api";
import { apiExcel } from "@/services/reports/apiExcel";
import { FacturasFacturas } from "@/types/reports/facturas/facturasFacturas/FacturasFacturas";
import { FacturaFilter } from "@/types/facturas/FacturaView";
import loading from "@/components/loading.vue";
import footerPage from "@/components/footerPage.vue";
import excelExport from "@/components/excelExport.vue";

export default defineComponent({
  name: "Listado1",
  components: {
    loading,
    footerPage,
    excelExport
  },
  setup() {
    const report: Ref<FacturasFacturas> = ref({
      totalGeneralImporte: "",
      facturas: []
    });

    const detail = ref(true);

    const isLoading = ref(true);

    async function getReport() {
      isLoading.value = true;
      const filterString = localStorage.getItem("facturaFilter");
      let filter = {} as FacturaFilter;
      if (filterString != undefined) filter = JSON.parse(filterString);
      //console.log('hola');
      const response = await api.getReportFacturasFacturasDB(filter);
      report.value = response;
      //console.log(report);
      isLoading.value = false;
    }

    async function getExcel() {
      const filterString = localStorage.getItem("facturaFilter");
      let filter = {} as FacturaFilter;
      if (filterString != undefined) filter = JSON.parse(filterString);
      apiExcel.getReportFacturasFacturasDB(filter);
    }

    onMounted(getReport);

    return {
      report,
      detail,
      isLoading,
      getExcel
    };
  }
});
